import * as React from 'react';
import { usePopover } from './usePopover';

export type PopoverContextValues = ReturnType<typeof usePopover> | null;

export const PopoverContext = React.createContext<PopoverContextValues>(null);

export function usePopoverContext() {
    const context = React.useContext(PopoverContext);
    if (context == null) {
        throw new Error('Popver child components must be wrapped in <Popover />');
    }
    return context;
}
